import "./App.css";
import LoginPage from "./Pages/LoginPage";
import { Routes, Route } from "react-router-dom";
import HomePage from "./Pages/HomePage";
import NewLogin from "./Login2";
import EmplRegistrationPage from "./Pages/EmplRegistrationPage";
import EmployeeListPage from "./Pages/EmployeeListPage";
import LeaveApprovalPage from "./Pages/LeaveApprovalPage";
import LeaveManagementPage from "./Pages/LeaveManagementPage";
import ViewEmpPage from "./Pages/ViewEmpPage";
import LeaveRejoinPage from "./Pages/LeaveRejoinPage";
import CreateAllowance from "./Components/Employee/CreateAllowance/CreateAllowance";
import EmployeeEditPage from "./Pages/EmployeeEditPage";
import LeaveCatPage from "./Pages/LeaveCatPage";
import LeaveAllotmentPage from "./Pages/LeaveAllotmentPage";
import LeaveApplicationPage from "./Pages/LeaveApplicationPage";
import AttendanceEvaluationPage from "./Pages/AttendanceEvaluationPage";
import TimesheetPage from "./Pages/TimesheetPage";
import PayrollManagementPage from "./Pages/PayrollManagementPage";
import HolidayManagementPage from "./Pages/HolidayManagementPage";
import AttendancePage from "./Pages/AttendancePage";
import LeavePage from "./Pages/LeavePage";
import BigCalendar from "./Components/Ghant/BigCalendar/BigCalendar";
import TaskGant from "./Components/Ghant/TaskGant/TaskGant";
import HomeNew from "./Pages/HomeNew";
import MachineValidation from "./MachineValidation";
import ProtectedRoute from "./ProtectedRoute";
import ProtectedMachine from "./ProtectedMachine";
import Wps from "./Components/Wps/Wps";
import MainPayroll from "./Components/Payroll/MainPayroll";
import GratuityMonitor from "./Components/EndOFService/GratuityMonitor";
import EndOfServiceApproval from "./Components/EndOFService/EndOfServiceApproval";
import EndOfServiceApplication from "./Components/EndOFService/EndOfServiceApplication";
import GratuityMonitorPrint from "./Components/EndOFService/GratuityMonitorPrint";
import FleetList from "./Components/FleetManagement/FleetList";
import FleetInformation from "./Components/FleetManagement/FleetInformation";
import FleetListPrint from "./Components/FleetManagement/FleetListPrint";
import EditEmpPrint from "./Components/Employee/EditEmp/EditEmpPrint";
import PayrollListPrint from "./Components/Payroll/PayrollListPrint";
import TimesheetReport from "./Components/Attendance/TimeSheet/TimesheetReport";
import EmployeeListReport from "./Components/Employee/EmployeeListReport";
import MonthlyAttendanceReport from "./Components/Attendance/MonthlyAttendanceReport";
import AbsenceReport from "./Components/Attendance/AbsenceReport";
import DailyAttendanceReport from "./Components/Attendance/DailyAttendanceReport";
import OvertimeReport from "./Components/Attendance/OvertimeReport";
import LateEarlyReport from "./Components/Attendance/LateEarlyReport";
import LeaveBalanceReport from "./Components/LeaveManagement/LeaveBalanceReport";
import LeaveLedger from "./Components/LeaveManagement/LeaveLedger";
import LeaveRequestsApprovalStatus from "./Components/LeaveManagement/LeaveRequestsApprovalStatus";
import LeaveEncashmentReport from "./Components/LeaveManagement/LeaveEncashmentReport";
import MedicalLeaveTracking from "./Components/LeaveManagement/MedicalLeaveTracking";
import EmployeeJoinExitReport from "./Components/Employee/EmployeeJoinExitReport";
import EmployeeProbationStatusReport from "./Components/Employee/EmployeeProbationStatusReport";
import EmployeeVisaIDExpiryReport from "./Components/Employee/EmployeeVisaIDExpiryReport";
import TimeSheetReportPreview from "./Components/Attendance/TimeSheet/TimeSheetReportPreview";
import AttendancePunchDetailsReportPreview from "./Components/Attendance/AttendancePunchDetailsPreview";
import AbsenceReportDocument from "./Components/Attendance/AbsenceReportDocument";
import AbsenceReportPreview from "./Components/Attendance/AbsenceReportPreview";
import OvertimeReportDocument from "./Components/Attendance/OvertimeReportDocument";
import OvertimeReportPreview from "./Components/Attendance/OvertimeReportPreview";
import LateEarlyReportPreview from "./Components/Attendance/LateEarlyReportPreview";
import EmployeeProbationStatusPreview from "./Components/Employee/EmployeeProbationStatusPreview";
import EmployeeJoinExitReportPreview from "./Components/Employee/EmployeeJoinExitPreview";
import TimeSheetSummaryReport from "./Components/Attendance/TimeSheetSummaryReport";
import TimeSheetSummaryReportPreview from "./Components/Attendance/TimeSheetSummaryPreview";
import AttendancePunchDetailsReport from "./Components/Attendance/AttendancePunchDetailsReport";
import ReportsMenu from "./Components/ReportsDirectory/ReportsMenu";
import LeaveLedgerPreview from "./Components/LeaveManagement/LeaveLedgerPreview";
import DocumentExpiry from "./Components/DocumentManagementDirectory/DocumentExpiry";
import DocumentManagement from "./Components/DocumentManagementDirectory/DocumentManagement";
import LeaveBalancePreview from "./Components/LeaveManagement/LeaveBalancePreview";
import LeaveRequestsApprovalPreview from "./Components/LeaveManagement/LeaveRequestsApprovalPreview";
import MedicalLeaveTrackingPreview from "./Components/LeaveManagement/MedicalLeaveTrackingPreview";

function App() {
  return (
    <Routes>
      <Route index element={<MachineValidation />} />
      <Route path="login" element={<NewLogin />} />

      <Route element={<ProtectedMachine />}>
        <Route element={<ProtectedRoute />}>
          <Route path="admin" element={<HomeNew />}>
            <Route path="home" element={<HomePage />} />
            <Route path="attendancePage" element={<AttendancePage />} />
            <Route path="leavePage" element={<LeavePage />} />
            <Route path="emp_list" element={<EmployeeListPage />} />
            <Route path="editEmpPrint" element={<EditEmpPrint />} />
            <Route path="emp_list/emp_reg" element={<EmplRegistrationPage />} />
            <Route path="emp_reg" element={<EmplRegistrationPage />} />
            <Route path="empJoinExitReport" element={<EmployeeJoinExitReport />} />
            <Route path="empStatusReport" element={<EmployeeProbationStatusReport />} />
            <Route path="empVisaIDExpiryReport" element={<EmployeeVisaIDExpiryReport />} />
            <Route path="createAllowance" element={<CreateAllowance />} />
            <Route
              path="admin/emp_list/emp_edit/createAllowance"
              element={<CreateAllowance />}
            />
            <Route
              path="emp_reg/createAllowance"
              element={<CreateAllowance />}
            />
            <Route
              path="emp_list/emp_edit/:id"
              element={<EmployeeEditPage />}
            />
            <Route
              path="emp_list/view_emp/emp_edit/:id"
              element={<EmployeeEditPage />}
            />
            <Route path="emp_list/view_emp/:id" element={<ViewEmpPage />} />
            <Route path="leavemanagement" element={<LeaveManagementPage />} />
            <Route path="leaveallotment" element={<LeaveAllotmentPage />} />
            <Route path="leaveapplication" element={<LeaveApplicationPage />} />
            <Route path="leaveapproval" element={<LeaveApprovalPage />} />
            <Route path="leaverejoin" element={<LeaveRejoinPage />} />
            <Route path="leavecat" element={<LeaveCatPage />} />
            <Route path="leaveBalanceReport" element={<LeaveBalanceReport />} />
            <Route path="leaveBalanceReportPrint" element={<LeaveBalancePreview />} />
            <Route path="leaveLedger" element={<LeaveLedger />} />
            <Route path="leaveLedgerPrint" element={<LeaveLedgerPreview />} />
            {/* <Route
              path="leaveEncashmentReport"
              element={<LeaveEncashmentReport />}
            /> */}
            <Route
              path="leaveRequestApprovalStatus"
              element={<LeaveRequestsApprovalStatus />}
            />
            <Route
              path="leaveRequestsApprovalPrint"
              element={<LeaveRequestsApprovalPreview />}
            />
            <Route
              path="medicalLeaveTracking"
              element={<MedicalLeaveTracking />}
            />
            <Route
              path="medicalLeaveTrackingPrint"
              element={<MedicalLeaveTrackingPreview />}
            />
            <Route
              path="atdcevaluation"
              element={<AttendanceEvaluationPage />}
            />
            <Route path="timesheet" element={<TimesheetPage />} />
            {/* <Route path="timesheetReport" element={<TimesheetReport />} /> */}
            <Route path="timesheetSummaryReport" element={<TimeSheetSummaryReport />} />
            <Route path="attendancePunchDetailsReport" element={<AttendancePunchDetailsReport />} />
            {/* <Route path="timeSheetSummaryPrint" element={<TimeSheetReportPreview />} /> */}
            <Route path="timeSheetSummaryReportPrint" element={<TimeSheetSummaryReportPreview />} />
            <Route path="attendancePunchDetailsPrint" element={<AttendancePunchDetailsReportPreview />} />
            <Route path="absenceReportPrint" element={<AbsenceReportPreview />} />
            <Route path="overtimeReportPrint" element={<OvertimeReportPreview />} />
            <Route path="lateEarlyReportPrint" element={<LateEarlyReportPreview />} />
            <Route path="employeeStatusReportPrint" element={<EmployeeProbationStatusPreview />} />
            <Route path="employeeJoinExitReportPrint" element={<EmployeeJoinExitReportPreview />} />
            <Route
              path="monthlyAttendanceReport"
              element={<MonthlyAttendanceReport />}
            />
            <Route
              path="dailyAttendanceReport"
              element={<DailyAttendanceReport />}
            />
            <Route path="absenceReport" element={<AbsenceReport />} />
            <Route path="overtimeReport" element={<OvertimeReport />} />
            <Route path="lateEarlyReport" element={<LateEarlyReport />} />
            <Route path="payroll" element={<PayrollManagementPage />} />
            <Route path="payrollMain" element={<MainPayroll />} />
            <Route path="holiday" element={<HolidayManagementPage />} />
            <Route path="bigCalendar" element={<BigCalendar />} />
            <Route path="taskGant" element={<TaskGant />} />
            <Route path="wps" element={<Wps />} />
            <Route path="gratuityMonitor" element={<GratuityMonitor />} />
            <Route
              path="gratuityMonitorPrint"
              element={<GratuityMonitorPrint />}
            />
            <Route
              path="endOfServiceApproval"
              element={<EndOfServiceApproval />}
            />
            <Route
              path="endOfServiceApplication"
              element={<EndOfServiceApplication />}
            />
            <Route path="fleetList" element={<FleetList />} />
            <Route path="fleetInformation" element={<FleetInformation />} />
            <Route path="fleetListPrint" element={<FleetListPrint />} />
            <Route path="employeeListReport" element={<EmployeeListReport />} />
            <Route path="payrollListPrint" element={<PayrollListPrint />} />
            <Route path="reportsMenu" element={<ReportsMenu />} />
            <Route path="documentManagement" element={<DocumentManagement />} />
            <Route path="documentExpiry" element={<DocumentExpiry />} />
          </Route>
        </Route>
      </Route>
    </Routes>
  );
}

export default App;
